<script>
	import OffsetWrapper from './OffsetWrapperG2.svelte';

	export let device;
</script>

<OffsetWrapper {device} setting={'humidity'} />
